package com.tovtalk.ui.components

/**
 * Media Aspect Ratios - Common video/image ratios
 * Shared across Android, iOS, Web.
 */
object MediaAspectRatio {
    /** Vertical video (TikTok/Reels style) - 9:16 */
    const val VERTICAL_VIDEO = 9f / 16f

    /** Square - 1:1 */
    const val SQUARE = 1f

    /** Horizontal video (YouTube style) - 16:9 */
    const val HORIZONTAL_VIDEO = 16f / 9f

    /** Portrait photo - 4:5 */
    const val PORTRAIT_PHOTO = 4f / 5f

    /** Landscape photo - 3:2 */
    const val LANDSCAPE_PHOTO = 3f / 2f

    /** Default fallback for unknown content */
    const val DEFAULT_FALLBACK = VERTICAL_VIDEO

    /**
     * Resolves aspect ratio from width and height.
     * Returns fallback if dimensions are invalid.
     */
    fun resolve(width: Int?, height: Int?, fallback: Float = DEFAULT_FALLBACK): Float {
        if (width == null || height == null || width <= 0 || height <= 0) {
            return fallback
        }
        return width.toFloat() / height.toFloat()
    }

    /**
     * Validates if ratio is within acceptable bounds.
     */
    fun isValidRatio(ratio: Float): Boolean {
        return ratio in 0.2f..5f
    }
}

/**
 * Content Scale Modes for Media Display
 */
enum class MediaScaleMode {
    FIT,
    CROP,
    FILL_WIDTH,
    FILL_HEIGHT
}
